<template>
  <a-drawer width="70%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('优惠券类型.领取明细') }}</b>
    </a-divider>

    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('优惠券类型.领取人')">
              <a-input
                v-model="queryParam.userInfo"
                :maxLength="32"
                :placeholder="$t('优惠券类型.领取人搜索提示')"
                allow-clear
                @pressEnter="handleQuery"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('优惠券类型.使用状态')">
              <a-select v-model="queryParam.state" allowClear :placeholder="$t('通用.输入.请选择')">
                <a-select-option
                  v-for="(item, index) in customDict.CouponReceiveStateEnum"
                  :value="item.type"
                  :key="index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="true"
    >
      <span slot="userInfo" slot-scope="text, record">
        <div class="user-info">
          <img v-if="record.avatar" :src="record.avatar" class="user-avatar" alt="avatar"/>
          <span v-else class="user-avatar-default"><a-icon type="user" /></span>
          <div class="user-text">
            <div>{{ $t('优惠券类型.昵称') }}：{{ record.nickName || '-' }}</div>
            <div>{{ $t('优惠券类型.手机号') }}：{{ record.mobile || '-' }}</div>
          </div>
        </div>
      </span>
      <span slot="fetchTime" slot-scope="text, record">
        {{ parseTime(record.fetchTime) }}
      </span>
      <span slot="useTime" slot-scope="text, record">
        {{ record.useTime ? parseTime(record.useTime) : '-' }}
      </span>
      <span slot="state" slot-scope="text, record">
        <custom-dict-tag :options="customDict.CouponReceiveStateEnum" :value="record.state"/>
      </span>
    </a-table>

    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />

    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="onClose">{{ $t('通用.按钮.关闭') }}</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { pageCouponReceiveUser } from '@/api/coupon/couponType'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'

export default {
  name: 'ReceiveUserForm',
  components: {
    CustomDictTag
  },
  data () {
    return {
      open: false,
      loading: false,
      total: 0,
      couponTypeId: undefined,
      list: [],
      queryParam: {
        couponTypeId: undefined,
        state: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('优惠券类型.领取人'),
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: 240,
          align: 'center'
        },
        {
          title: this.$t('优惠券类型.领取时间'),
          dataIndex: 'fetchTime',
          scopedSlots: { customRender: 'fetchTime' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('优惠券类型.使用时间'),
          dataIndex: 'useTime',
          scopedSlots: { customRender: 'useTime' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('优惠券类型.使用状态'),
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' },
          width: 120,
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    /** 打开领取人明细 */
    handleReceiveUser (record) {
      this.couponTypeId = record.id
      this.queryParam = {
        couponTypeId: record.id,
        state: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.open = true
      this.getList()
    },
    getTotal (total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询领取人明细分页 */
    getList () {
      this.loading = true
      const param = { ...this.queryParam }
      // 用户信息搜索框同时匹配昵称和手机号（OR 关系）
      if (param.userInfo) {
        param.nickName = param.userInfo
      }
      delete param.userInfo
      pageCouponReceiveUser(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        couponTypeId: this.couponTypeId,
        state: undefined,
        userInfo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onClose () {
      this.open = false
      this.list = []
      this.total = 0
    }
  }
}
</script>

<style lang="less" scoped>
.user-info {
  display: flex;
  align-items: center;
  justify-content: center;

  .user-avatar,
  .user-avatar-default {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .user-avatar-default {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f2f5;
    color: #bfbfbf;
  }

  .user-text {
    text-align: left;
    line-height: 18px;
  }
}
</style>
